module.exports = __webpack_public_path__ + "static/media/  (134).b4d8907b.jpg";